import React from "react";
import {RemoveDuplicatesConfiguration} from "./configuration/remove-duplicates-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const RemoveDuplicatesStepPanelTabs = {
    configuration: RemoveDuplicatesConfiguration,
    preview: PreviewTab,
};
